<div class="mobile-filter-overlay">
  <div class="mobile-filter-panel">
    <div class="mobile-filter-header">
      <div class="mobile-filter-title" fiTranslation="REQUEST_OVERVIEW_FILTER_AND_SORT"></div>
      <fi-button
        variant="tertiary"
        tone="neutral"
        size="lg"
        [iconOnly]="true"
        class="mobile-filter-close"
        (click)="closed.emit()"
      >
        <mat-icon fiButtonIcon>close</mat-icon>
        <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
      </fi-button>
    </div>

    <div class="mobile-filter-body">
      <section class="mobile-filter-section" [class.expanded]="expandedMobileSection === 'search'">
        <button type="button" class="section-toggle" (click)="toggleMobileSection('search')">
          <span fiTranslation="REQUEST_OVERVIEW_FILTER_SEARCH_IN_CATEGORY"></span>
          <img src="assets/icons/arrow-up.svg" alt="Toggle">
        </button>

        @if (expandedMobileSection === 'search') {
          <div class="section-content">
            <form class="mobile-search-form search-field-inner" (submit)="$event.preventDefault(); applyMobileFilters()">
              <img src="assets/icons/search-dark.svg" alt="Search" class="search-icon">
              <input
                #mobileFilterSearch
                id="mobile-filter-search"
                type="search"
                class="search-input"
                name="mobile-filter-search"
                [(ngModel)]="mobileSearchText"
                fiTranslation="SEARCH_PLACEHOLDER"
                [isPLaceHolder]="true"
                >
              @if (mobileSearchText) {
                <button
                  type="button"
                  class="clear-input"
                  (click)="clearMobileSearchText()"
                  >
                  <mat-icon class="clear-icon">close</mat-icon>
                </button>
              }
            </form>
            @for (category of categoryTypes; track category) {
              <label class="radio-row">
                <input
                  type="radio"
                  name="mobile-category"
                  [value]="category.categoryKey"
                  [(ngModel)]="selectedCategoryKey"
                  >
                <span>{{ category.categoryName }}</span>
              </label>
            }
          </div>
        }
      </section>

      <section class="mobile-filter-section" [class.expanded]="expandedMobileSection === 'sort'">
        <button type="button" class="section-toggle" (click)="toggleMobileSection('sort')">
          <span fiTranslation="REQUEST_OVERVIEW_FILTER_SORT_BY"></span>
          <img src="assets/icons/arrow-up.svg" alt="Toggle">
        </button>

        @if (expandedMobileSection === 'sort') {
          <div class="section-content">
            <label class="radio-row">
              <input type="radio" name="mobile-sort-direction" value="ASC" [(ngModel)]="mobileSortDirection">
              <span fiTranslation="REQUEST_OVERVIEW_FILTER_SORT_ASCENDING"></span>
            </label>
            <label class="radio-row">
              <input type="radio" name="mobile-sort-direction" value="DESC" [(ngModel)]="mobileSortDirection">
              <span fiTranslation="REQUEST_OVERVIEW_FILTER_SORT_DESCENDING"></span>
            </label>
            <div class="section-divider"></div>
            @for (sortType of mobileSortTypes; track sortType) {
              <label class="radio-row">
                <input type="radio" name="mobile-sort-type" [value]="sortType.value" [(ngModel)]="mobileSortType">
                <span [fiTranslation]="sortType.labelKey"></span>
              </label>
            }
          </div>
        }
      </section>

      <section class="mobile-filter-section" [class.expanded]="expandedMobileSection === 'showOnly'">
        <button type="button" class="section-toggle" (click)="toggleMobileSection('showOnly')">
          <span fiTranslation="REQUEST_OVERVIEW_FILTER_SHOW_ONLY"></span>
          <img src="assets/icons/arrow-up.svg" alt="Toggle">
        </button>

        @if (expandedMobileSection === 'showOnly') {
          <div class="section-content">
            <fi-checkbox [(ngModel)]="filters.onlyMyLeads"><span fiTranslation="REQUEST_OVERVIEW_FILTER_MY_REQUESTS"></span></fi-checkbox>
            <fi-checkbox [(ngModel)]="filters.openLeads"><span fiTranslation="REQUEST_OVERVIEW_FILTER_OPEN_REQUESTS"></span></fi-checkbox>
            <fi-checkbox [(ngModel)]="filters.closedLeads"><span fiTranslation="REQUEST_OVERVIEW_FILTER_COMPLETED_REQUESTS"></span></fi-checkbox>
            <fi-checkbox [(ngModel)]="filters.unreadLeads"><span fiTranslation="REQUEST_OVERVIEW_FILTER_UNREAD_REQUESTS"></span></fi-checkbox>
          </div>
        }
      </section>

      <section class="mobile-filter-section" [class.expanded]="expandedMobileSection === 'createdOn'">
        <button type="button" class="section-toggle" (click)="toggleMobileSection('createdOn')">
          <span fiTranslation="SEARCH_DATE"></span>
          <img src="assets/icons/arrow-up.svg" alt="Toggle">
        </button>

        @if (expandedMobileSection === 'createdOn') {
          <div class="section-content">
            <div class="mobile-date-field">
              <button type="button" class="mobile-date-input" (click)="toggleMobileDatePicker()">
                <img src="assets/icons/new/calendar.svg" alt="calendar">
                <span [class.placeholder]="!mobileDateRangeText">
                  {{ mobileDateRangeText || 'Choose date' }}
                </span>
                @if (mobileDateRangeText) {
                  <mat-icon
                    class="mobile-date-clear"
                    (click)="clearMobileDateRange($event)"
                  >close</mat-icon>
                }
              </button>
              @if (mobileDatePickerOpen) {
                <fi-day-range-picker
                  class="mobile-date-filter"
                  [fromDate]="mobileDateRange?.[0]"
                  [toDate]="mobileDateRange?.[1]"
                  [unfocused]="false"
                  (dateRangeSelected)="onDateRangeSelected($event)"
                ></fi-day-range-picker>
              }
            </div>
          </div>
        }
      </section>

      <section class="mobile-filter-section" [class.expanded]="expandedMobileSection === 'type'">
        <button type="button" class="section-toggle" (click)="toggleMobileSection('type')">
          <span fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_LEAD_TYPE"></span>
          <img src="assets/icons/arrow-up.svg" alt="Toggle">
        </button>

        @if (expandedMobileSection === 'type') {
          <div class="section-content">
            @for (type of leadTypes; track type) {
              <fi-checkbox
                [checked]="isSelected(filters.leadTypes, type, 'Id')"
                (checkedChange)="toggleSelection('leadTypes', type, 'Id')"
                >
                <span>{{ type.Description }}</span>
              </fi-checkbox>
            }
          </div>
        }
      </section>

      <section class="mobile-filter-section" [class.expanded]="expandedMobileSection === 'contact'">
        <button type="button" class="section-toggle" (click)="toggleMobileSection('contact')">
          <span fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_CONTACT"></span>
          <img src="assets/icons/arrow-up.svg" alt="Toggle">
        </button>

        @if (expandedMobileSection === 'contact') {
          <div class="section-content">
            @for (contactType of contactTypes; track contactType) {
              <fi-checkbox
                [checked]="isSelected(filters.contactTypes, contactType, 'Id')"
                (checkedChange)="toggleSelection('contactTypes', contactType, 'Id')"
                >
                <span>{{ contactType.Description }}</span>
              </fi-checkbox>
            }
          </div>
        }
      </section>

      <section class="mobile-filter-section" [class.expanded]="expandedMobileSection === 'country'">
        <button type="button" class="section-toggle" (click)="toggleMobileSection('country')">
          <span fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_COUNTRY"></span>
          <img src="assets/icons/arrow-up.svg" alt="Toggle">
        </button>

        @if (expandedMobileSection === 'country') {
          <div class="section-content">
            <div class="mobile-text-input-wrapper">
              <input
                class="mobile-text-input"
                type="search"
                [(ngModel)]="countrySearchText"
                fiTranslation="SEARCH_PLACEHOLDER"
                [isPLaceHolder]="true"
                >
              @if (countrySearchText) {
                <button
                  type="button"
                  class="clear-input"
                  (click)="clearCountrySearchText()"
                  >
                  <mat-icon class="clear-icon">close</mat-icon>
                </button>
              }
            </div>
            <div class="country-list">
              @for (country of filteredCountries; track country) {
                @if (country.IsPriority || countrySearchText) {
                  <fi-checkbox
                    [checked]="isSelected(filters.countries, country, 'IsoCode')"
                    (checkedChange)="toggleSelection('countries', country, 'IsoCode')"
                    >
                    <span>{{ country.Name }}</span>
                  </fi-checkbox>
                }
              }
            </div>
            @if (countrySearchText && !filteredCountries.length) {
              <div
                class="empty-filter-message"
                fiTranslation="REQUEST_OVERVIEW_FILTER_NO_COUNTRIES_FOUND"
              ></div>
            }
          </div>
        }
      </section>

      <section class="mobile-filter-section" [class.expanded]="expandedMobileSection === 'status'">
        <button type="button" class="section-toggle" (click)="toggleMobileSection('status')">
          <span fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_STATUS"></span>
          <img src="assets/icons/arrow-up.svg" alt="Toggle">
        </button>

        @if (expandedMobileSection === 'status') {
          <div class="section-content">
            @for (status of visibleLeadStatuses; track status) {
              <fi-checkbox
                [checked]="isSelected(filters.leadStatuses, status, 'Id')"
                (checkedChange)="toggleSelection('leadStatuses', status, 'Id')"
                >
                <span>{{ status.Text }}</span>
              </fi-checkbox>
            }
            @if (shouldShowMoreStatusesButton) {
              <button
                type="button"
                class="show-more-btn"
                (click)="showAllStatuses = true"
                fiTranslation="REQUEST_OVERVIEW_FILTER_SHOW_MORE_STATUS_OPTIONS"
              ></button>
            }
          </div>
        }
      </section>

      <section class="mobile-filter-section" [class.expanded]="expandedMobileSection === 'responsible'">
        <button type="button" class="section-toggle" (click)="toggleMobileSection('responsible')">
          <span fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_RESPONSIBLE"></span>
          <img src="assets/icons/arrow-up.svg" alt="Toggle">
        </button>

        @if (expandedMobileSection === 'responsible') {
          <div class="section-content">
            <input
              class="mobile-text-input"
              type="search"
              [(ngModel)]="mobileResponsibleSearchText"
              fiTranslation="SEARCH_PLACEHOLDER"
              [isPLaceHolder]="true"
              >
            @if (isFinstralUser) {
              <fi-checkbox
                [checked]="!!filters.premiumProjectCustomerTypes?.length"
                (checkedChange)="togglePremiumPartner()"
                >
                <span fiTranslation="REQUEST_OVERVIEW_FILTER_PREMIUM_PARTNER"></span>
              </fi-checkbox>
            }
          </div>
        }
      </section>

      <section class="mobile-filter-section" [class.expanded]="expandedMobileSection === 'deadline'">
        <button type="button" class="section-toggle" (click)="toggleMobileSection('deadline')">
          <span fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_DUE_DATE"></span>
          <img src="assets/icons/arrow-up.svg" alt="Toggle">
        </button>

        @if (expandedMobileSection === 'deadline') {
          <div class="section-content">
            @for (deadlineStatus of deadlineStatuses; track deadlineStatus) {
              <fi-checkbox
                [checked]="isSelected(filters.deadlineStatus, deadlineStatus, 'Id')"
                (checkedChange)="toggleSelection('deadlineStatus', deadlineStatus, 'Id')"
                >
                <span [fiTranslation]="deadlineStatus.Text"></span>
              </fi-checkbox>
            }
          </div>
        }
      </section>
    </div>

    <div class="mobile-filter-footer">
      <button type="button" class="apply-filters-btn" (click)="applyMobileFilters()" fiTranslation="REQUEST_OVERVIEW_FILTER_APPLY"></button>
    </div>
  </div>
</div>
